import AbstractAPI from './AbstractAPI';

export default new class extends AbstractAPI {
    route = '/role';
}();
